<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card class="v-em">
      <v-toolbar color="#f9f9f9">
        <v-toolbar-title>{{ readonly ? "查看员工信息":"填写员工信息"}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container>
        <v-layout v-if="!readonly" justify-end>
          <v-btn :href="templateUrl" color="primary" flat>下载模板</v-btn>
          <a href="javascript:;" class="outputlist_upload">批量上传
            <input type="file" ref="upload" accept=".xls, .xlsx"/>
          </a>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-form ref="form" lazy-validation>
              <v-data-table :headers="headers" :items="items" hide-actions class="employee-table">
                <template slot="items" slot-scope="props">
                  <tr v-if="props.item._isEdit">
                    <td>
                      <v-text-field v-model="props.item.insuredName" :rules="rules.name"></v-text-field>
                    </td>
                    <td>
                      <v-layout justify-center align-center>
                        <v-select
                          v-model="props.item.relationWithMain"
                          :items="relationItmes"
                          item-text="name"
                          item-value="id"
                          :rules="rules.relation"
                          class="v-select"
                        ></v-select>
                      </v-layout>
                    </td>
                    <td>
                      <v-layout justify-center align-center>
                        <v-select
                          v-model="props.item.identifyType"
                          :items="certificate"
                          item-text="name"
                          item-value="id"
                          :rules="rules.certificate"
                          class="v-select"
                        ></v-select>
                      </v-layout>
                    </td>
                    <td v-if="props.item.identifyType === 1">
                      <v-text-field v-model.trim="props.item.identifyNumber" :rules="rules.idCard"></v-text-field>
                    </td>
                    <td v-else>
                      <v-text-field v-model.trim="props.item.identifyNumber" :rules="rules.idCard1"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="props.item.mobilephone" :rules="rules.phone"></v-text-field>
                    </td>
                    <td>
                      <JobCategory
                        v-model="props.item.occupation"
                        :rules="rules.category"
                        :limit="3"
                      ></JobCategory>
                    </td>
                    <td>
                      <v-checkbox
                        v-model="props.item.healthStatus"
                        :label="props.item.healthStatus ? '是':'否'"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox
                        v-model="props.item.hasSocialInsurance"
                        :label="props.item.hasSocialInsurance ? '有':'无'"
                      ></v-checkbox>
                    </td>
                    <td>
                      <v-text-field
                        v-model.trim="props.item.mainIdentifyNumber"
                        v-if="props.item.relationWithMain === '01'"
                      ></v-text-field>
                      <v-text-field
                        v-model.trim="props.item.mainIdentifyNumber"
                        v-else
                        :rules="rules.mainIdentifyNumber"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-layout justify-center align-center>
                        <v-select
                          v-model="props.item.plan"
                          :rules="rules.plan"
                          :items="planChildren"
                          item-text="name"
                          item-value="planId"
                          return-object
                          class="v-select"
                          v-if="props.item.relationWithMain === '40'"
                        ></v-select>
                        <v-select
                          v-model="props.item.plan"
                          :rules="rules.plan"
                          :items="planAdult"
                          item-text="name"
                          item-value="planId"
                          return-object
                          class="v-select"
                          v-else
                        ></v-select>
                      </v-layout>
                    </td>
                    <td>
                      <v-btn
                        v-if="props.index===0"
                        color="primary"
                        outline
                        @click.native="onCreate(props.index)"
                      >添加</v-btn>
                      <v-btn v-else color="primary" outline @click.native="onSave(props.index)">保存</v-btn>
                    </td>
                  </tr>
                  <tr v-else>
                    <td>{{ props.item.insuredName }}</td>
                    <td v-if="props.item.relationWithMain === '01'">本人</td>
                    <td v-else-if="props.item.relationWithMain === '10'">配偶</td>
                    <td v-else-if="props.item.relationWithMain === '40'">子女</td>
                    <td v-if="props.item.identifyType === 1">居民身份证</td>
                    <td v-else-if="props.item.identifyType === 2">护照</td>
                    <td v-else-if="props.item.identifyType === 3">军人证</td>
                    <td v-else-if="props.item.identifyType === 4">驾驶证</td>
                    <td v-else-if="props.item.identifyType === 5">港澳台同胞证</td>
                    <td v-else-if="props.item.identifyType === 7">中国护照</td>
                    <td v-else-if="props.item.identifyType === 99">其他</td>
                    <td>{{ props.item.identifyNumber }}</td>
                    <td>{{ props.item.mobilephone }}</td>
                    <td>{{ props.item.occupation.name }}</td>
                    <td>{{ props.item.healthStatus ? '健康体' :'非健康体'}}</td>
                    <td>{{ props.item.hasSocialInsurance ? '有社保' :'无社保'}}</td>
                    <td>{{ props.item.mainIdentifyNumber }}</td>
                    <td>{{ props.item.plan && props.item.plan.name}}</td>
                    <td v-if="!readonly" class="text-xs-center">
                      <!-- todo:后续再做编辑 -->
                      <!-- <v-btn flat class="operation-btn" @click="onEdit(props.index)">编辑</v-btn> -->
                      <v-btn flat class="operation-btn" @click="onDelete(props.index)">删除</v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout class="mt-4">
          <v-flex>
            <strong>
              员工总数：
              <em class="em">{{ employees.length }}</em> 人
            </strong>
            <span>（本人 {{ oneselfCount }} 人，配偶 {{ spouseCount }} 人，子女 {{ childrenCount }} 人）</span>
          </v-flex>
          <v-flex shrink>
            <v-btn v-if="!readonly" color="primary" @click="confirm" block>确定</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import XLSX from 'xlsx';
import JobCategory from "@/components/Order/TKJobCategory";
import validate from "@/assets/js/validate";
import dateUtil from "@/assets/js/utils/date";
export default {
  components: {
    JobCategory
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      templateUrl:
        "https://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/%E6%B3%B0%E5%BA%B7%E5%9C%A8%E7%BA%BF%E4%BC%81%E4%B8%9A%E5%9B%A2%E9%99%A9%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx",
      headers: [
        {
          text: "姓名",
          value: "name",
          sortable: false
        },
        {
          text: "与员工关系",
          value: "relation",
          sortable: false
        },
        {
          text: "证件类型",
          value: "certificate",
          sortable: false
        },
        {
          text: "身份证号",
          value: "idCard",
          sortable: false
        },
        {
          text: "手机号",
          value: "phone",
          sortable: false
        },
        {
          text: "职业类别",
          value: "category",
          sortable: false
        },
        {
          text: "是否健康体",
          value: "health",
          sortable: false
        },
        {
          text: "有无社保",
          value: "social",
          sortable: false
        },
        {
          text: "主被保人证件号",
          value: "mainIdentifyNumber",
          sortable: false
        },
        {
          text: "产品方案",
          value: "plan",
          sortable: false
        },
        {
          text: "操作",
          sortable: false,
          align: "center"
        }
      ],
      planItmes: [],
      items: [],
      relationItmes: [
        {
          id: "01",
          name: "本人"
        },
        {
          id: "10",
          name: "配偶"
        },
        {
          id: "40",
          name: "子女"
        }
      ],
      certificate: [
        {
          id: 1,
          name: "居民身份证"
        },
        {
          id: 2,
          name: "护照"
        },
        {
          id: 3,
          name: "军人证"
        },
        {
          id: 5,
          name: "港澳台同胞证 "
        },
        {
          id: 7,
          name: "中国护照"
        },
        {
          id: 99,
          name: "其他"
        }
      ],
      editObjTemplate: {
        _isEdit: true,
        _status: 0, // 0 还未添加，1：已添加未保存，2：已保存
        insuredName: "",
        relationWithMain: "",
        identifyNumber: "",
        mainIdentifyNumber: "",
        mobilephone: "",
        identifyType: "",
        healthStatus: true,
        hasSocialInsurance: false,
        plan: "",
        occupation: {
          code: "",
          name: "",
          level: 0
        }
      },
      rules: {
        name: [
          v => {
            if (!v) {
              return "请输入姓名";
            }
            if (!validate.isChineseName(v)) {
              return "姓名格式错误，请重新输入";
            }
            return true;
          }
        ],
        relation: [
          v => {
            if (!v) {
              return "请选择与员工关系";
            }
            return true;
          }
        ],
        certificate: [
          v => {
            if (!v) {
              return "请选择与员工关系";
            }
            return true;
          }
        ],
        idCard: [
          v => {
            if (!v) {
              return "请输入身份证号";
            }
            if (!validate.isIDCard(v)) {
              return "请输入正确的身份证号";
            }
            if (
              this.items.findIndex(item => !item._isEdit && item.idCard === v) >
              -1
            ) {
              return "身份证号重复，请重新输入";
            }
            const birthday = dateUtil.getBirthdayByID(v);
            const age = dateUtil.getAge(birthday);
            if (age < -1 || age > 60) {
              return "年龄未在承保范围（0周岁 - 60周岁）";
            }
            return true;
          }
        ],
        idCard1: [v => !!v || "请输入证件号"],
        mainIdentifyNumber: [v => !!v || "请输入身份证号"],
        phone: [
          v => {
            if (!v) {
              return "请输入手机号";
            }
            if (!validate.isMobilePhone(v)) {
              return "手机号格式错误，请重新输入";
            }
            return true;
          }
        ],
        category: [
          v => {
            if (!v) {
              return "请选择职业类别";
            }
            const codes = this.items.map(item => item.occupation.code);
            const count = Array.from(new Set(codes)).length;
            if (count > 17) {
              return "单次投保中最多支持17种不同的职业，如超过请分开投保";
            }
            return true;
          }
        ],
        plan: [v => !!v || "请选择方案"]
      }
    };
  },
  mounted() {
    this.$refs.upload.addEventListener('change', e => {//绑定监听表格导入事件
      this.readExcel(e);
    })
  },
  computed: {
    dialog: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      }
    },
    categories() {
      let arr = [];
      this.$store.state.insure.tkcategories.map(item=>{
        arr.push(item.children);
      });
      return arr.flat();
    },
    categories1() {
      let arr = [];
      this.categories.map(item=>{
        arr.push(item.children);
      });
      return arr.flat();
    },
    employees() {
      return this.items.filter(item => item._status !== 0);
    },
    oneselfCount() {
      return this.employees.filter(item => item.relationWithMain === "01").length;
    },
    spouseCount() {
      return this.employees.filter(item => item.relationWithMain === "10").length;
    },
    childrenCount() {
      return this.employees.filter(item => item.relationWithMain === "40").length;
    },
    planAdult() {
      let arr = [];
      this.planItmes.filter(item => {
        if (item.id <= 12) {
          arr.push(item);
        }
      });
      return arr;
    },
    planChildren() {
      let arr = [];
      this.planItmes.filter(item => {
        if (item.id > 12) {
          arr.push(item);
        }
      });
      return arr;
    }
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.items = this.value.map(item => item);
        if (!this.readonly) {
          this.addEditItem();
        }
      }
    }
  },
  created() {
    if (this.readonly) {
      this.headers.pop();
    }
    this.$axios.get("/json/tk_ip.json").then(data => {
      this.planItmes = data;
    });
  },
  methods: {
    readExcel(e) {
      //表格导入
      const files = e.target.files;
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]).slice(6); //生成json表格内容        
          const json = ws.filter(item => Object.keys(item).length > 8);
          json.map(item =>{
            console.log(item);
            this.items.push({
              _isEdit: false,
              _status: 1, // 0 还未添加，1：已添加未保存，2：已保存
              insuredName: item.__EMPTY,
              relationWithMain: this.getRelation(item.__EMPTY_1),
              // relationWithMain: item.__EMPTY_1,
              identifyNumber: item.__EMPTY_3.trim(),
              mainIdentifyNumber: item.__EMPTY_8 ? item.__EMPTY_8.trim() : "",
              mobilephone: item.__EMPTY_4,
              identifyType: this.getIdentifyType(item.__EMPTY_2),
              healthStatus:item.__EMPTY_6 === '是'?true :false,
              hasSocialInsurance: item.__EMPTY_7 === '有' ?true:false,
              plan: this.getPlan(item.__EMPTY_9),
              occupation: this.getOccupation(item.__EMPTY_5)
            });
          });
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },
    getRelation(val){
      if (val == '本人') {
        return '01'
      } else if (val == '配偶') {
        return '10'
      } else if (val == '子女') {
        return '40'
      }
    },
    getIdentifyType(val){
      return this.certificate.find(item => item.name == val).id;
    },
    getPlan(val){
      console.log(val);
      console.log(this.planItmes.find(item =>item.name === val));
      return this.planItmes.find(item =>item.name === val);
    },
    getOccupation(val){
      return this.categories1.find(item =>item.code === val.trim());
    },
    addEditItem() {
      const editItem = Object.assign({}, this.editObjTemplate);
      this.items.unshift(editItem);
    },
    onCreate(index) {
      if (this.$refs.form.validate()) {
        let item = this.items[index];
        item._isEdit = false;
        item._status = 1;
        // 永远保持一个编辑的行在第一行
        this.addEditItem();
        this.$refs.form.resetValidation();
      }
    },
    onEdit(index) {
      let newItem = this.items[index];
      newItem._isEdit = true;
      this.items.splice(index, 1, newItem);
    },
    onSave(index) {
      if (this.$refs.form.validate()) {
        let item = this.items[index];
        item._isEdit = false;
        item._status = 1;
        // 永远保持一个编辑的行在第一行
        this.addEditItem();
        this.$refs.form.resetValidation();
      }
    },
    onDelete(index) {
      this.items.splice(index, 1);
    },
    onUploadError(err) {
      // this.$message.error(err.message);
      let error = err.message.replace(/;/g, "<br>");
      const message =
        "您导入的员工信息中有格式错误，请修改后重新上传，具体错误信息如下所示：<br>" +
        error;
      this.$messageBox.alert({
        message,
        width: 500
      });
    },
    confirm() {
      if (this.employees.length < 3) {
        this.$message.error("员工人数需达3人，请继续补充人数");
        return false;
      }
      this.dialog = false;
      this.$emit("input", this.employees);
    }
  }
};
</script>

<style lang="scss">
.v-em {
  .operation-btn {
    min-width: auto;
    margin: 6px 0;
  }
  .employee-table {
    .v-table__overflow {
      max-height: 700px;
      overflow: auto;
    }
  }
}
table.v-table tbody td:first-child,
table.v-table tbody td:not(:nth-child(1)) {
  padding: 0 16px;
}
.outputlist_upload {
    position: relative;
    display: inline-block;
    background: #dd122a;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #fff;
    text-decoration: none;
    text-indent: 0;
    margin-top: 5px;
    height: 34px;
    font-size: 14px;
    line-height: 28px;
    font-weight: bold;
}
.outputlist_upload input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
}
.outputlist_upload:hover {
    background: #dd122a;
    border-color: #dd122a;
    color: #fff;
    text-decoration: none;
}
</style>

